import { useLocation } from 'react-router-dom';
import { isAnonymizedPathname } from 'Douleutaras/hooks/localization';

// True for routes listed in ANONYMIZED_PATHS (e.g. pro-profile) — cached at the Cloudflare edge,
// so SSR skips auth resolution and always renders as logged-out. Consumers use this to gate
// auth-dependent UI until client mount, avoiding a hydration mismatch against that logged-out
// server render.
export const useIsAnonymizedRoute = (): boolean => {
  const { pathname } = useLocation();

  return isAnonymizedPathname(pathname);
};
